"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unMinifyNegated = exports.minifyNegated = void 0;
function minifyNegated(params) {
    const negated = params.value;
    return Number(negated);
}
exports.minifyNegated = minifyNegated;
function unMinifyNegated(params) {
    const minifiedNegated = params.value;
    return Boolean(minifiedNegated);
}
exports.unMinifyNegated = unMinifyNegated;
//# sourceMappingURL=negatedMinifier.js.map